import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../api/index';
import { Toast, Popup, InfiniteScroll } from 'antd-mobile-v5';
import { withRouter } from 'react-router-dom';
import styles from './index.module.scss';
import icon_plus from '../../static/images_cso/icon_plus.png';
import icon_search from '../../static/images_doctor/tool_introdce_search.png';
import icon_search_clear from '../../static/images_medicalLive/search_clear.png';
import patient_avatar from '../../static/images_cso/patient_avatar.png';
import filter from '../../static/images_cso/filter.png';
import registered from '../../static/images_cso/registered.png';
import suggested from '../../static/images_cso/suggested.png';
import payed from '../../static/images_cso/payed.png';
import recieved from '../../static/images_cso/recieved.png';
import closed from '../../static/images_cso/closed.png';
import refund from '../../static/images_cso/refund.png';
import list_circle_full from '../../static/images_cso/list_circle_full.png';
import NoRecord from '../component/noRecord';
const api = new ApiCore();

const stateMap = {
    10: '已建议',
    51: '已支付',
    52: '已拒绝',
    60: '已完成',
    99: '已关闭'
};

const filters = [
    {state: 10, text: '已建议'}, 
    {state: 51, text: '已支付'},
    {state: 52, text: '已拒绝'},
    {state: 60, text: '已完成'},
    {state: 99, text: '已关闭'} 
]

let delayExcute:any = null;

const CSOPatient = (props: any) => {

    const [recordStatistics, setRecordStatistics] = useState<any>({});
    const [successRateArr, setSuccessRateArr] = useState<any>([]);
    const [popVisible, setPopVisible] = useState<boolean>(false);
    const [searchKey, setSearchKey] = useState<any>(null);
    const [list, setList] = useState<any>([]);
    const [filterIndex, setFilterIndex] = useState<any>(-1);
    const [nowState, setNowState] = useState<any>(0);

    const [isMore, setIsMore] = useState<any>(true);
    const [page, setPage] = useState<any>(0);
    const [pageSize, setPageSize] = useState<any>(10);
    const [total, setTotal] = useState<any>(null);
    const [listReady, setListReady] = useState<any>(false);
    ;
    useEffect(() => {
        getStatistics();
        return () => {
        }
    }, [])

    // 搜索标题变化
    const titleInput = (event: any) => {
        setSearchKey(event.target.value);
    }

    // 清除输入内容
    const clearInput = () => {
        setSearchKey('');
    }

    useEffect(() => {
        clearTimeout(delayExcute);
        if (searchKey !== null) {
            delayExcute = setTimeout(() => {
                setPage(1);
                getTasks(1);
            }, 300);
        }
    }, [searchKey])
    
    const getStatistics = () => {
        const doctor_info = sessionStorage.getItem('cso_doctor_info');
        if (doctor_info) {
            let doctorInfo = JSON.parse(doctor_info);
            const _projects = doctorInfo.projects || [];
            let _project0 = (_projects && _projects[0]) || ''
            api.getDoctorRecordStatistics({
                projectCode: _project0
            }).then((res: any) => {
                if (res.code == 0) {
                    setRecordStatistics(res.data || {});
                    let rate = res.data.inquiryCreateNum == 0 ? 0 : (res.data.signInNum / res.data.inquiryCreateNum);
                    let rateNumber = Math.floor(rate * 10);
                    let rate100 = rate * 100;
                    let num_0_9 = 0;
                    if (rate100 < 10) {
                        num_0_9 = rate100;
                    } else {
                        num_0_9 = ((rate100 / 10) - Math.floor(rate100 / 10)) * 10;
                    }
                    let rateArray = new Array(10).fill({
                        rateNumber: rateNumber,
                        rate100: rate100,
                        num_0_9: num_0_9
                    });
                    setSuccessRateArr(rateArray);
                }
            });
        }
    }

    const getTasks = (curPage?: number, recordState?: number) => {
        let _page = curPage ? curPage : page
        const mState = { recordState };
        const param = {
            "page": _page,
            "pageSize": pageSize,
            "content": searchKey,
            ...mState
        };
        setListReady(false);
        api.getCsoDoctorPatientsInfo(param).then((res: any) => {
                if (res.code == 0) {
                    const _data = res.data || {};
                    const _list = curPage == 1 ? _data.rows : list.concat(_data.rows);
                    setIsMore(_list.length < res.data.total)
                    setList(_list);
                    setListReady(true);
                }
        });
    }

    const getData = () => {
        return new Promise<any>((resolve, reject) => {
            if (total !== null && page * pageSize >= total) {
                setIsMore(false);
                resolve([]);
            }
            let _page = page;
            _page++;
            setPage(_page)
            const mState = nowState ? {
                recordState: nowState
            }: {};
            const param = {
                "page": _page,
                "pageSize": pageSize,
                "content": searchKey,
                ...mState
            };
            api.getCsoDoctorPatientsInfo(param).then((res: any) => {
                if (res.code == 0) {
                    setTotal(res.data?.total)
                    if (_page * pageSize >= res.data?.total) {
                        setIsMore(false);
                    }
                    resolve(res.data?.rows);
                }
            })
        })
    }

    const renderColorClass = (val: any) => {
        const state = val.recordState;
        if (state == 10) {
            return styles.suggested;
        } else if (state == 51) {
            return styles.payed;
        } else if (state == 60) {
            return styles.recieved;
        } else if (state == 99) {
            return styles.closed;
        } else if (state == 52) {
            return styles.refund; // 已拒绝
        } else {
            return styles.registered;
        }
    }

    const renderImg = (val: any) => {
        const state = val.recordState;
        if (state == 10) {
            return <img src={suggested} alt="" />;
        } else if (state == 51) {
            return <img src={payed} alt="" />;
        } else if (state == 60) {
            return <img src={recieved} alt="" />;
        } else if (state == 99) {
            return <img src={closed} alt="" />;
        } else if (state == 52) {
            return <img src={refund} alt="" />;
        } else {
            return <img src={registered} alt="" />;
        }
    }

    const onFilterSelect = (val: any, key: number) => {
        if (key == filterIndex) {
            setFilterIndex(-1);
        } else {
            setFilterIndex(key);
        }
    }

    //当点击列表item
    const onClickListItem = (item: any) => {
        sessionStorage.setItem('cso_patient_detail_info', JSON.stringify(item));
        props.history.push('/cso/patient/patientDetail?phone=' + item.phone);
    }

    const filterSelect = () => {
        setPopVisible(!popVisible)
    }

    const onReset = () => {
        setFilterIndex(-1);
        setNowState(0);
        setPage(1);
        setPopVisible(false);
        getTasks(1)
    }

    const onConfirm = () => {
        setPage(1);
        setPopVisible(false);
        let nowState = filters[filterIndex]?.state;
        setNowState(nowState);
        getTasks(1, nowState)
    }

    async function loadMore() {
        setListReady(false);
        const append = await getData();
        setList((val: any) => [...val, ...append]);
        setListReady(true);
    }

    const fakeName = (name: string) => {
        if (name) {
            if (name.length == 1) {
                return name;
            } else if (name.length == 2) {
                return name[0] + '*';
            } else {
                return name[0] + '*'.repeat(name.length - 2) + name[name.length -1];
            }
        }
        return '';
    }

    return (
        <div className={styles.CSO_patient_content}>
            <div className={styles.home_content}>
                <div className={`${styles.bg_head} ${styles.bg_head_project_research}`}>
                    {/* <div style={{ textAlign: 'center', width: '100%'}}>
                        我的患者
                    </div> */}
                </div>
                <div className={styles.body}>
                {/* <div className={styles.body_head}>
                    <div className={styles.task_list_search_header}>
                        <div className={styles.head}>
                            <div className={styles.title}>
                                我的患者
                            </div>
                            <div className={styles.search_wrap}>
                                <div className={`${styles.tool_introduce_head}`}>
                                    <div className={styles.search_head}>
                                        <div className={styles.search}>
                                            <img className={styles.search_img} src={icon_search} alt="" />
                                            <input type="text" placeholder="按姓名/手机号查询" value={searchKey} onChange={(event) => { titleInput(event) }} />
                                            {
                                                searchKey &&
                                                <img className={`${styles.search_img_clear}`} src={icon_search_clear} alt="" onClick={ () => { clearInput() }} />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.add_task_wrap} onClick={() => { }}>
                                <div className={styles.add_task}>
                                    <img src={icon_plus} alt="" />
                                    <span className={styles.add_task_text}>添加患者</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
                <div className={styles.body_head}>
                    <div className={styles.task_list_search_header}>
                        <div className={styles.head}>
                            <div className={styles.title}>
                                我的患者
                            </div>
                            <div className={styles.middle}>
                            </div>
                            <div className={styles.select} onClick={filterSelect}>
                                <img src={filter} alt="" />
                                <div>{ nowState == 0 ? '' : '已'}筛选</div>
                            </div>
                        </div>
                        <div className={styles.head_b}>
                            <div className={styles.search_wrap}>
                                    <div className={`${styles.tool_introduce_head}`}>
                                        <div className={styles.search_head}>
                                            <div className={styles.search}>
                                                <img className={styles.search_img} src={icon_search} alt="" />
                                                <input type="text" placeholder="按姓名/手机号查询" value={searchKey} onChange={(event) => { titleInput(event) }} />
                                                {
                                                    searchKey &&
                                                    <img className={`${styles.search_img_clear}`} src={icon_search_clear} alt="" onClick={ () => { clearInput() }} />
                                                }
                                            </div>
                                        </div>
                                    </div>
                            </div>
                        </div>
                        <div className={styles.head_count}>
                            <div className={styles.head_count_item}>
                                <div className={styles.head_count_item_t}>已注册</div>
                                <div> <span className={styles.count}>{recordStatistics.registerNum || 0}</span> <span>人</span></div>
                            </div>
                            <div className={styles.head_count_item}>
                                <div className={styles.head_count_item_t}>已建议</div>
                                <div> <span className={styles.count}>{recordStatistics.inquiryCreateNum || 0}</span> <span>次</span></div>
                            </div>
                            {/* <div className={styles.head_count_item}>
                                <div className={styles.head_count_item_t}>已支付</div>
                                <div> <span className={styles.count}>{recordStatistics.paySuccessNum || 0}</span> <span>次</span></div>
                            </div>
                            <div className={styles.head_count_item}>
                                <div className={styles.head_count_item_t}>已收货</div>
                                <div> <span className={styles.count}>{recordStatistics.signInNum || 0}</span> <span>次</span></div>
                            </div> */}
                            <div className={`${styles.head_count_item} ${styles.progress}`}>
                                <div className={styles.head_count_item_t}>荐方成功率</div>
                                {/* <div> <span className={styles.count}>{recordStatistics.signInNum || 0}</span> <span>次</span></div> */}
                                <div> 
                                    {
                                        successRateArr.map((val: any, key: number) => (
                                            <div key={key} className={`${styles.progress_un_active}`}>
                                                {/* <div className={`${key < val.rateNumber ? styles.progress_active: ''}  ${key == val.rateNumber ? styles.not_full : ''}`} style={{ width: `${( key < val.rateNumber ? '100' : (val.num_0_9 / 10) * 100)}%`, height: '100%'}}>
                                                </div>
                                                {
                                                    (key == val.rateNumber) && val.num_0_9 && !isNaN(val.num_0_9) && val.num_0_9 >= 1 && val.num_0_9 < 10 &&
                                                    <img src={require(`../../static/images_cso/list_full_circle/list_circle_full_${Math.floor(val.num_0_9)}.png`).default} />
                                                } */}
                                                {
                                                    key < val.rateNumber &&
                                                    <div className={`${styles.progress_active}`} 
                                                    >
                                                    </div>
                                                }
                                                {
                                                    key == val.rateNumber &&
                                                    <div className={styles.progress_half}  style={{ width: `${( (val.num_0_9 / 10) * 100)}%`, height: '100%'}}>
                                                        <img src={list_circle_full} />
                                                    </div>
                                                }
                                            </div>
                                        ))
                                    }
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                    {/* {
                        statistics && (statistics.length > 0) &&
                        <div className={styles.all_statics}>
                        {
                            statistics && statistics.map((val: any, index) => (
                                <div key={index} style={{width: statistics.length <= 5 ? ((1 / statistics.length) * 100 + '%') : '20%'}}
                                    className={activeStaticsIndex === index ? styles.statics_active : ''}
                                    onClick={ ()=> { statisticsSelect(val, index) }}
                                >
                                    <div>{val.name}</div>
                                    <div>{val.count}</div>
                                </div>
                            ))
                        }
                        </div>
                    } */}
                    <div className={`${styles.list_content} ${props.bottomMore ? styles.list_content_more : ''}`}>
                        {
                            list && list.map((item: any, key: number) => (
                                <div key={key} className={styles.list} onClick={() => { onClickListItem(item) }}>
                                <div className={styles.listItem}>
                                    <div className={styles.portrait}>
                                        <img src={patient_avatar} alt="defaultAvatar" />
                                    </div>
                                    <div className={styles.info_content}>
                                        <div className={styles.info_top}>
                                        <div className={styles.id}>
                                            <div className={styles.subName}>
                                                <span className={styles.title_name}>{fakeName(item.patientName)}</span>
                                                <span className={styles.phone}>{item.phone ? item.phone.replace(/(\d{3})(\d{4})(\d{4})/, "$1 **** $3") : ''}</span>
                                            </div>
                                            <div className={styles.subCode}>{item.projectName}</div>
                                        </div>
                                        <div style={{ flex: 1, height: '100%' }}></div>
                                        <div className={styles.banner_text_new}>
                                                {renderImg(item)}
                                                <span className={`${renderColorClass(item)}`}>
                                                    {stateMap[item.recordState] || '已注册'}
                                                </span>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            ))
                        }
                        { listReady &&  list.length == 0 &&
                            <NoRecord>
                                暂无记录
                            </NoRecord>
                        }
                        <InfiniteScroll loadMore={loadMore} hasMore={isMore} >{''}</InfiniteScroll>
                    </div>
                </div>
            </div>
            <Popup
              visible={popVisible}
              position='top'
              onMaskClick={() => {
                setPopVisible(false)
              }}
            >
              <div className={styles.cso_patient_pop_container}>
                    <div className={styles.head}>
                        患者筛选
                    </div>
                    <div className={styles.body}>
                        将根据患者最近一次处方状态进行筛选
                    </div>
                    <div className={styles.filter_state}>
                        {
                            filters.map((val: any, key: number) => (
                                <div key={key} className={`${ filterIndex == key ? styles.active : styles.un_active}`} onClick={() => { onFilterSelect(val, key) }}>{val.text}</div>
                            ))
                        }
                    </div>
                    <div className={styles.confirm_btns}>
                        <div className={styles.reset} onClick={() => { onReset() }}>重置</div>
                        <div className={styles.confirm} onClick={() => { onConfirm() }}>确认筛选</div>
                    </div>
              </div>
            </Popup>
        </div>
    )
}

export default withRouter(CSOPatient);